<script lang="ts" setup>
import { useDate } from '~/composables/useDate';

export interface DatesItem {
  datetime: string;
  title: string;
  description?: string;
}

interface Props {
  item: DatesItem;
}

const props = defineProps<Props>();

const { day, monthShort } = useDate(props.item.datetime);
</script>

<template>
  <div class="date-item">
    <div class="date-item__date-box">
      <time v-if="monthShort" class="date-item__month">{{ monthShort }}</time>
      <time v-if="day" class="date-item__day">{{ day }}</time>
    </div>
    <div class="date-item__body">
      <strong v-if="item.title" class="date-item__title">{{ item.title }}</strong>
      <p v-if="item.description" class="date-item__description">{{ item.description }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.date-item {
  @apply w-full flex items-center gap-5 py-[31px] border-b border-base-color/20;
  @apply xl:gap-10;

  &__date-box {
    @apply flex flex-col gap-2 items-center justify-center p-1 min-w-[90px] min-h-[90px] border border-accent/30 rounded-[24px];
    @apply xl:min-w-[130px] xl:min-h-[130px];
  }

  &__month {
    @apply text-[14px] font-medium text-accent uppercase leading-none;
  }

  &__day {
    @apply font-title text-accent text-[40px] leading-none;
    @apply xl:text-[45px];
  }

  &__body {
    @apply flex flex-col gap-3;
  }

  &__title {
    @apply font-medium text-[20px] leading-[1.1];
    @apply xl:text-[24px];
  }

  &__description {
    @apply text-base-color/70 text-[14px] leading-[1.3];
    @apply xl:text-[16px];
  }
}
</style>
